import { useErrorContext } from '@/contexts/ErrorContext';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';
import { FormattedMessage } from 'react-intl';

const ErrorModalManager = () => {
  const { errors, removeError } = useErrorContext();
  const currentError = errors[errors.length - 1];

  if (!currentError) {
    return null;
  }

  const handleAction = () => {
    removeError(currentError.id);
  };

  return (
    <Modal
      open={true}
      title={currentError.title}
      onClose={handleAction}
      actions={[
        <Button
          key="close"
          variant="contained"
          onClick={handleAction}
          aria-label="Close Button"
        >
          <FormattedMessage id="Close" defaultMessage="Close" />
        </Button>,
      ]}
    >
      {currentError.message}
    </Modal>
  );
};

export default ErrorModalManager;
